import { useQueryClient } from '@tanstack/react-query';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
import { matchDismissalRequest, settleDismissals, undoOfBatchDismissal, undoOfSingleDismissal } from '~/utils/revenueOpportunities/opportunityDismissals';
import { revenueOpportunitiesSummaryKey } from '~/utils/revenueOpportunities/revenueOpportunitiesQueryKeys';
export const useDismissRevenueOpportunity = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutateAsync } = useMutationState({
        mutationFn: async (param)=>{
            let { requests, businessId } = param;
            const settled = settleDismissals(requests, await Promise.allSettled(requests.map(sendDismissal)));
            if (settled.mayHaveChanged) {
                await queryClient.invalidateQueries({
                    queryKey: revenueOpportunitiesSummaryKey(businessId)
                });
            }
            return settled;
        }
    });
    function sendDismissal(request) {
        return matchDismissalRequest(request, {
            single: (body)=>api.pulse.createDismissal(body).then(undoOfSingleDismissal),
            batch: (body)=>api.pulse.createDismissals(body).then(undoOfBatchDismissal)
        });
    }
    return {
        dismissRevenueOpportunity: mutateAsync
    };
};
